export const environment = {
  //This is the production environment for local machine development
  production: true,
  //RestServer: 'https://localhost:7005/api/',
};
